

import React, { useState } from 'react';

interface Props {
  onAdd: (guid: string, term: string) => void;
}

const QuickRefForm: React.FC<Props> = ({ onAdd }) => {
  const [noticeId, setNoticeId] = useState('');
  const [guid, setGuid] = useState('');
  const [term, setTerm] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    let finalGuid = guid;

    // If GUID is not provided, try to fetch it from the backend using the notice ID
    if (!finalGuid && noticeId) {
      try {
        const response = await fetch(`/api/guid-from-notice-id/${encodeURIComponent(noticeId)}`);
        const result = await response.json();
        if (result.status === 'success') {
          finalGuid = result.guid;
        } else {
          alert('Failed to find GUID from Notice ID');
          return;
        }
      } catch (error) {
        console.error('Error fetching GUID:', error);
        alert('Error fetching GUID');
        return;
      }
    }

    if (!finalGuid || !term) {
      alert('Please provide a GUID or Notice ID, and a term');
      return;
    }

    onAdd(finalGuid, term);
    setNoticeId('');
    setGuid('');
    setTerm('');
  };

  return (
    <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
      <input
        type="text"
        placeholder="Notice ID (optional)"
        value={noticeId}
        onChange={(e) => setNoticeId(e.target.value)}
      />
      <input
        type="text"
        placeholder="GUID (optional)"
        value={guid}
        onChange={(e) => setGuid(e.target.value)}
      />
      <input
        type="text"
        placeholder="Quick reference term"
        value={term}
        onChange={(e) => setTerm(e.target.value)}
        required
      />
      <button type="submit">Add</button>
    </form>
  );
};

export default QuickRefForm;